import React from 'react'
import { CodeBlock } from '@driftt/tide-core'
import { buildItemWidget } from '../config'
import StartBuildingButton from '../StartBuildingButton'
import ConditionalRender from 'components/ConditionalRender'
import './style.css'

const resolveConfig = (selectedBuildItemType) =>
  buildItemWidget.find(item => item.buildItemType === selectedBuildItemType)

const BuildItemWidget = ({ selectedBuildItemType }) => {
  const config = resolveConfig(selectedBuildItemType)

  return (
    <div className="build-item-widget">
      <div className="build-item-widget-cover">
        <ConditionalRender condition={config.codeBlock}>
          <CodeBlock>
            {config.codeBlock}
          </CodeBlock>
        </ConditionalRender>
        <ConditionalRender condition={config.coverImageSrc}>
          <img src={config.coverImageSrc} alt="cover" />
        </ConditionalRender>
        <ConditionalRender condition={config.coverVideoSrc}>
          <video width="100%" height="auto" autoPlay loop>
            <source src={config.coverVideoSrc} type="video/mp4" />
          </video>
        </ConditionalRender>
      </div>
      <div className="build-item-widget-body">
        <span className="build-item-widget-name">
          {config.name}
        </span>
        <p className="build-item-widget-description">
          {config.description}
        </p>
        <StartBuildingButton size="small" />
      </div>

    </div>
  )
}

export default BuildItemWidget
